<template>
  <form-box :title="$t('message.Booking.disabledInfo')">
    <div class="itnal_info_box" v-for="item in value" :key="item.id">
      <MyCell>
        <MyCellItem :label="$t('message.Booking.forbidBookingDate')">
          <template slot="value">
            {{ $formatDate(item.hitStartDate, "dd/MM/yyyy") }} ~
            {{ $formatDate(item.hitEndDate, "dd/MM/yyyy") }}
          </template>
        </MyCellItem>
        <MyCellItem
          :label="$t('message.Booking.forbidBookingCause')"
          :value="item.reason"
        ></MyCellItem>
      </MyCell>
    </div>
  </form-box>
</template>
<script>
import FormBox from "./FormBox.vue";
import MyCell from "@/components/MyCell.vue";
import MyCellItem from "@/components/MyCellItem.vue";

export default {
  components: {
    FormBox,
    MyCell,
    MyCellItem,
  },
  props: {
    value: Array,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.itnal_info_box {
  border: 1px solid #d0d0d0;
  border-radius: 10px;
  overflow: hidden;
  margin: 16px auto;
}
</style>
